export enum Languages {
	Arabic = "ar",
	English = "en",
}
